module.exports = __webpack_public_path__ + "img/dashboard-approved.95b57889.svg";